export enum Color {
  Primary600 = 'primary.600',
  Primary500 = 'primary.500',
  Primary200 = 'primary.200',
  OnPrimary = 'onPrimary',
  Secondary = 'secondary',
  OnSecondary = 'onSecondary',
  Surface = 'surface',
  OnSurface = 'onSurface',
  Overlay = 'overlay',
  Shade100 = 'shade.100',
  Shade200 = 'shade.200',
  Shade500 = 'shade.500',
  Shade600 = 'shade.600',
  Disabled = 'disabled',
  Danger300 = 'danger.300',
  Danger400 = 'danger.400',
  Danger500 = 'danger.500',
  OnDanger = 'onDanger',
  Error = 'error.500',
  OnError = 'onError',
  Background = 'background',
  OnBackground = 'onBackground',
  Transparent = 'transparent',
  Success = 'success',
  Profit = 'profit',
  Loss = 'loss',
  Light = 'light',
  OnLight = 'onLight',
  SecondaryButton = 'secondaryButton',
  OnSecondaryButton = 'onSecondaryButton',
}

export interface ColorScheme {
  [Color.Primary600]: string;
  [Color.Primary500]: string;
  [Color.Primary200]: string;
  [Color.OnPrimary]: string;
  [Color.Secondary]: string;
  [Color.OnSecondary]: string;
  [Color.Surface]: string;
  [Color.OnSurface]: string;
  [Color.Overlay]: string;
  [Color.Shade100]: string;
  [Color.Shade200]: string;
  [Color.Shade500]: string;
  [Color.Shade600]: string;
  [Color.Disabled]: string;
  [Color.Danger300]: string;
  [Color.Danger400]: string;
  [Color.Danger500]: string;
  [Color.OnDanger]: string;
  [Color.Error]: string;
  [Color.OnError]: string;
  [Color.Background]: string;
  [Color.OnBackground]: string;
  [Color.Success]: string;
  [Color.Profit]: string;
  [Color.Loss]: string;
  [Color.Light]: string;
  [Color.OnLight]: string;
  [Color.SecondaryButton]: string;
  [Color.OnSecondaryButton]: string;
  [Color.Transparent]: string;
}

const colorScheme: ColorScheme = {
  [Color.Primary600]: '#2BAF91',
  [Color.Primary500]: '#40D9B5',
  [Color.Primary200]: '#D9F8F0',
  [Color.OnPrimary]: '#fff',
  [Color.Secondary]: '#fff',
  [Color.OnSecondary]: '#000',
  [Color.Surface]: '#fff',
  [Color.OnSurface]: '#000',
  [Color.Overlay]: 'rgba(0, 0, 0, 0.8)',
  [Color.Shade100]: '#f5f5f5',
  [Color.Shade200]: '#e4ecf0',
  [Color.Shade500]: '#9f9f9f',
  [Color.Shade600]: '#7c7c7c',
  [Color.Disabled]: 'gray',
  [Color.Danger300]: 'rgba(255, 0, 0, 0.5)',
  [Color.Danger400]: '#ff7f7f',
  [Color.Danger500]: '#db1915',
  [Color.OnDanger]: '#fff',
  [Color.Error]: '#db1915',
  [Color.OnError]: '#fff',
  [Color.Background]: '#f5f5f5',
  [Color.OnBackground]: '#000',
  [Color.Success]: '#40D9B5',
  [Color.Profit]: '#40D9B5',
  [Color.Loss]: '#ff7f7f',
  [Color.Light]: '#fff',
  [Color.OnLight]: '#000',
  [Color.SecondaryButton]: '#323232',
  [Color.OnSecondaryButton]: '#fff',
  [Color.Transparent]: 'transparent',
};

export const greenColorScheme = {
  50: '#ECFBF7',
  100: '#D9F8F0',
  200: '#B3F1E1',
  300: '#80E8D1',
  400: '#40D9B5',
  500: '#40D9B5',
  600: '#2BAF91',
  700: '#228873',
  800: '#1D6D5D',
  900: '#19594D',
};

export default colorScheme;
